// pages/Home.jsx
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from '@mui/material';
import { Link } from 'react-router-dom';

import salon1 from '../assets/images/salon-1.jpg';
import salon2 from '../assets/images/salon-2.jpg';
import salon3 from '../assets/images/salon-3.jpg';
import serviceManicure from '../assets/images/service-manicure.jpg';
import serviceBrowsLashes from '../assets/images/service-brows-lashes.jpg';
import serviceHair from '../assets/images/service-hair.jpg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Rating from '@mui/material/Rating'; 
import AboutSection from '../components/AboutSection';
import Portfolio from '../components/Portfolio';
import Reviews from '../components/Reviews';
import DiscountSection from '../components/DiscountSection';
import MapSection from '../components/MapSection';

const serviceCategories = [
  {
    id: 'manicure-pedicure',
    title: 'Маникюр и педикюр',
    description: 'Уход за руками и ногами, покрытие гель-лаком, spa-ритуалы и дизайн.',
    image: serviceManicure,
    price: 'от 1500 ₽',
    externalLink: 'https://n893698.yclients.com/company/833095/personal/select-services?o=s26222981', // ← сюда
  },
  {
    id: 'brows-lashes',
    title: 'Брови и ресницы',
    description: 'Архитектура бровей, окрашивание, ламинирование, наращивание ресниц.',
    image: serviceBrowsLashes,
    price: 'от 1800 ₽',
    externalLink: 'https://n893698.yclients.com/company/833095/personal/select-services?o=s26222981', // ← сюда
  },
  {
    id: 'hair',
    title: 'Парикмахерские услуги',
    description: 'Стрижки, уходовые процедуры и окрашивание по последним трендам.',
    image: serviceHair,
    price: 'от 2500 ₽',
    externalLink: 'https://n893698.yclients.com/company/833095/personal/select-services?o=s26222981', // ← сюда
  },
];

const Home = () => {
  return (
    <Box sx={{ background: '#f4f4f2' }}>
      {/* ===== БАННЕР (без изменений, оставляем как есть) ===== */}
      <Box
        sx={{
          position: 'relative',
          py: { xs: 4, md: 6 },
          overflow: 'hidden',
          background: `
            radial-gradient(circle at 12% 18%, rgba(201, 161, 74, 0.18) 0%, transparent 26%),
            radial-gradient(circle at 85% 22%, rgba(26, 35, 126, 0.16) 0%, transparent 28%),
            radial-gradient(circle at 75% 80%, rgba(201, 161, 74, 0.10) 0%, transparent 24%),
            linear-gradient(180deg, #ececeb 0%, #e4e4e2 100%)
          `,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            background:
              'linear-gradient(135deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 38%, rgba(26,35,126,0.035) 100%)',
          }}
        />
        <Container
          maxWidth="xl"
          sx={{ px: { xs: 2, md: 4 }, position: 'relative', zIndex: 1 }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'stretch',
              justifyContent: 'space-between',
              gap: { xs: 4, md: 5 },
            }}
          >
            {/* Левая часть — текст + кнопки */}
            <Box
              sx={{
                flex: 1.1,
                position: 'relative',
                bgcolor: 'rgba(255,255,255,0.82)',
                borderRadius: 6,
                p: { xs: 3, md: 5 },
                border: '1px solid rgba(26,35,126,0.08)',
                boxShadow: `
                  0 22px 55px rgba(0,0,0,0.08),
                  0 8px 24px rgba(26,35,126,0.06),
                  inset 0 1px 0 rgba(255,255,255,0.7)
                `,
                backdropFilter: 'blur(8px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: -80,
                  right: -80,
                  width: 220,
                  height: 220,
                  borderRadius: '50%',
                  background:
                    'radial-gradient(circle, rgba(201,161,74,0.22) 0%, transparent 70%)',
                  pointerEvents: 'none',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -70,
                  left: -70,
                  width: 220,
                  height: 220,
                  borderRadius: '50%',
                  background:
                    'radial-gradient(circle, rgba(26,35,126,0.10) 0%, transparent 70%)',
                  pointerEvents: 'none',
                }}
              />
              <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontFamily: '"Playfair Display", serif',
                    color: '#14245f',
                    mb: 2.5,
                    lineHeight: 1.1,
                    fontWeight: 700,
                    letterSpacing: '-0.02em',
                    textShadow: '0 1px 0 rgba(255,255,255,0.45)',
                    fontSize: { xs: '1.9rem', md: '2.4rem' },
                  }}
                >
                  ВСЕ BEAUTY УСЛУГИ
                  <br />
                  В ОДНОМ МЕСТЕ
                </Typography>
                <Box
                  sx={{
                    fontSize: 17,
                    mb: 1.6,
                    color: '#14245f',
                    fontWeight: 700,
                    position: 'relative',
                    display: 'inline-block',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      left: -10,
                      right: -10,
                      bottom: -4,
                      height: '62%',
                      background:
                        'linear-gradient(90deg, rgba(201,161,74,0.14) 0%, rgba(201,161,74,0.42) 45%, rgba(201,161,74,0.18) 100%)',
                      borderRadius: '999px',
                      boxShadow: '0 6px 18px rgba(201,161,74,0.18)',
                      zIndex: 0,
                    }}
                  />
                  <Typography
                    component="span"
                    sx={{
                      position: 'relative',
                      zIndex: 1,
                      fontSize: 17,
                      fontWeight: 700,
                      color: '#14245f',
                    }}
                  >
                    Скидка 20%
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: 15,
                    opacity: 0.9,
                    mb: 2,
                    color: '#2d3553',
                    lineHeight: 1.7,
                  }}
                >
                  новым клиентам при записи на сайте, кроме сложного окрашивания.
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    opacity: 0.78,
                    mb: 3,
                    color: '#3f4763',
                    lineHeight: 1.8,
                    maxWidth: 520,
                  }}
                >
                  Разнообразие услуг в одной студии: маникюр, педикюр, ресницы и
                  парикмахерский зал.
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Button
                    component={Link}
                    to="/contacts"
                    variant="contained"
                    size="large"
                    sx={{
                      borderRadius: 999,
                      px: 4,
                      textTransform: 'none',
                      fontWeight: 700,
                      color: '#fff',
                      background:
                        'linear-gradient(135deg, #15255f 0%, #1a237e 60%, #2c3ea8 100%)',
                      boxShadow:
                        '0 14px 30px rgba(26,35,126,0.28), 0 4px 14px rgba(201,161,74,0.14)',
                      '&:hover': {
                        background:
                          'linear-gradient(135deg, #101d4d 0%, #162067 60%, #24348d 100%)',
                      },
                    }}
                  >
                    Записаться онлайн
                  </Button>
                  <Button
  variant="text"
  onClick={() => window.open('https://n893698.yclients.com/company/833095/personal/select-services?o=', '_blank')}
  sx={{
    textTransform: 'none',
    color: '#1a237e',
    fontWeight: 700,
    px: 1,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 8,
      right: 8,
      bottom: 6,
      height: 2,
      borderRadius: 999,
      background:
        'linear-gradient(90deg, rgba(201,161,74,0) 0%, rgba(201,161,74,0.85) 50%, rgba(201,161,74,0) 100%)',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#12205f',
    },
  }}
>
  Смотреть прайс
</Button>
                </Box>
              </Box>
              <Box
  sx={{
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mt: 3,
    pt: 2.2,
    borderTop: '1px solid rgba(26,35,126,0.08)',
    flexWrap: 'wrap',
    gap: 2,
  }}
>
  <Box>
    <Typography sx={{ fontSize: 13, opacity: 0.78, color: '#2f3654' }}>
      Более 1000 довольных клиентов
    </Typography>
    <Typography sx={{ fontSize: 13, opacity: 0.78, color: '#2f3654' }}>
      Рейтинг 5.0 в 2ГИС и Яндекс
    </Typography>
  </Box>

  {/* ЗВЁЗДЫ вместо аватарок */}
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Rating value={5} readOnly size="large" sx={{ color: '#ffd700' }} />
    <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#14245f' }}>
      5.0
    </Typography>
  </Box>
</Box>
            </Box>

            {/* Правая часть — фото */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 6,
                  overflow: 'hidden',
                  boxShadow:
                    '0 18px 44px rgba(0,0,0,0.12), 0 6px 18px rgba(26,35,126,0.08)',
                  height: { xs: 220, md: 260 },
                  border: '1px solid rgba(255,255,255,0.5)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    zIndex: 1,
                    background:
                      'linear-gradient(135deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 32%, rgba(201,161,74,0.08) 100%)',
                    pointerEvents: 'none',
                  },
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    zIndex: 1,
                    boxShadow: 'inset 0 0 0 1px rgba(201,161,74,0.18)',
                    pointerEvents: 'none',
                  },
                }}
              >
                <Box
                  component="img"
                  src={salon1}
                  alt="Процедура Lindos Beauty"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    transform: 'scale(1.01)',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      'linear-gradient(180deg, rgba(10,12,24,0.06) 0%, rgba(10,12,24,0.14) 100%)',
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  height: { xs: 120, md: 140 },
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    position: 'relative',
                    borderRadius: 6,
                    overflow: 'hidden',
                    boxShadow:
                      '0 14px 34px rgba(0,0,0,0.10), 0 4px 14px rgba(201,161,74,0.08)',
                    border: '1px solid rgba(255,255,255,0.52)',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: 0,
                      zIndex: 1,
                      background:
                        'linear-gradient(135deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 36%, rgba(26,35,126,0.06) 100%)',
                      pointerEvents: 'none',
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={salon2}
                    alt="Команда Lindos Beauty"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    position: 'relative',
                    borderRadius: 6,
                    overflow: 'hidden',
                    boxShadow:
                      '0 14px 34px rgba(0,0,0,0.10), 0 4px 14px rgba(26,35,126,0.08)',
                    border: '1px solid rgba(255,255,255,0.52)',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: 0,
                      zIndex: 1,
                      background:
                        'linear-gradient(135deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 36%, rgba(201,161,74,0.08) 100%)',
                      pointerEvents: 'none',
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={salon3}
                    alt="Интерьер студии Lindos Beauty"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* ===== БЛОК "НАШИ УСЛУГИ" (теперь с id="services") ===== */}
      <Container id="services" sx={{ py: 8 }}>
        <Typography
          variant="h3"
          textAlign="center"
          gutterBottom
          sx={{
            fontFamily: '"Playfair Display", serif',
            color: '#14245f',
            mb: 5,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            textShadow: '0 1px 0 rgba(255,255,255,0.4)',
          }}
        >
          Наши услуги
        </Typography>

        <Grid container spacing={4}>
          {serviceCategories.map((service) => (
            <Grid size={{ xs: 12, md: 4 }} key={service.id}>
              <Card
                sx={{
                  textDecoration: 'none',
                  borderRadius: 4,
                  overflow: 'hidden',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(249,249,248,0.98) 100%)',
                  border: '1px solid rgba(26,35,126,0.08)',
                  boxShadow:
                    '0 14px 34px rgba(0,0,0,0.07), 0 5px 14px rgba(26,35,126,0.04)',
                  transition:
                    'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow:
                      '0 22px 46px rgba(0,0,0,0.12), 0 10px 22px rgba(201,161,74,0.10)',
                    borderColor: 'rgba(201,161,74,0.35)',
                  },
                  '&:hover .service-arrow': {
                    transform: 'translateX(3px)',
                  },
                }}
              >
                <Box sx={{ position: 'relative', height: 190 }}>
                  <Box
                    component="img"
                    src={service.image}
                    alt={service.title}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      background:
                        'linear-gradient(180deg, rgba(10,12,24,0.06) 0%, rgba(10,12,24,0.22) 100%)',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 12,
                      left: 12,
                      bgcolor: 'rgba(20,36,95,0.72)',
                      color: 'white',
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 999,
                      fontSize: 11,
                      textTransform: 'uppercase',
                      letterSpacing: 1,
                      boxShadow: '0 8px 18px rgba(20,36,95,0.18)',
                      backdropFilter: 'blur(4px)',
                    }}
                  >
                    категория
                  </Box>
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      boxShadow: 'inset 0 0 0 1px rgba(201,161,74,0.18)',
                      pointerEvents: 'none',
                    }}
                  />
                </Box>

                <CardContent
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    p: 2.5,
                  }}
                >
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      fontFamily: '"Playfair Display", serif',
                      color: '#14245f',
                      fontWeight: 700,
                    }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      mb: 2,
                      minHeight: 56,
                      lineHeight: 1.7,
                    }}
                  >
                    {service.description}
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mt: 'auto',
                      pt: 1.5,
                      borderTop: '1px solid rgba(26,35,126,0.06)',
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: '#b2872f',
                        fontWeight: 700,
                        fontSize: 15,
                      }}
                    >
                      {service.price}
                    </Typography>

                    {/* Кнопка "Перейти" теперь ведёт на внешний сайт */}
                    <Button
                      size="small"
                      endIcon={
                        <ArrowForwardIosIcon
                          className="service-arrow"
                          sx={{
                            fontSize: 14,
                            transition: 'transform 0.3s ease',
                          }}
                        />
                      }
                      sx={{
                        textTransform: 'none',
                        fontSize: 13,
                        fontWeight: 700,
                        color: '#1a237e',
                      }}
                      onClick={() => window.open(service.externalLink, '_blank')}
                    >
                      Перейти
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* ===== ОСТАЛЬНЫЕ СЕКЦИИ ===== */}
      <AboutSection />
      <Portfolio />
      <Reviews />
      <DiscountSection />
      <MapSection />
    </Box>
  );
};

export default Home;